import ApiService from './api.service'
import { TokenService } from './storage.service'

const folderFileNavService = {
    navGPOContractFolder: async (payload) => {
        const requestData = {
            method: 'post',
            url: '/api/folderFileNav/navGPOContractFolder',
            data: payload,
        }
        try {
            const response = await ApiService.customRequest(requestData)
            return response.data
        }
        catch (err) {
            throw err
        }
    },
 
}

export default folderFileNavService